export var ObjectStatusColor;
(function (ObjectStatusColor) {
    ObjectStatusColor["Offer"] = "#FFD440";
    ObjectStatusColor["Reservation"] = "#FF7A30";
    ObjectStatusColor["Contract"] = "#DB0012";
})(ObjectStatusColor || (ObjectStatusColor = {}));
export var ObjectCategory;
(function (ObjectCategory) {
    ObjectCategory["Offer"] = "offer";
    ObjectCategory["Reservation"] = "reservation";
    ObjectCategory["Contract"] = "contract";
})(ObjectCategory || (ObjectCategory = {}));
